module.exports = __webpack_public_path__ + "img/twitter-512.d7c6644a.png";